import FroalaEditor from 'froala-editor';

type FroalaButton = {
  attr: (name: string, value: boolean) => FroalaButton;
  toggleClass: (name: string, state: boolean) => FroalaButton;
};

type FroalaFormatAttributes = Record<string, string>;

type FroalaEditorInstance = {
  el: HTMLElement;
  format: {
    is: (tagName: string, attributes: FroalaFormatAttributes) => boolean;
    toggle: (tagName: string, attributes: FroalaFormatAttributes) => void;
  };
};

type FroalaCommand = {
  callback: (this: FroalaEditorInstance) => void;
  focus: boolean;
  refresh: (this: FroalaEditorInstance, $btn: FroalaButton) => void;
  refreshAfterCallback: boolean;
  title: string;
  toggle: boolean;
  undo: boolean;
};

export const NUM_GROUP_COMMAND = 'numGroup';
export const NUM_GROUP_TITLE = 'Prevent line break';

const NO_BREAK_TAG = 'span';
const NO_BREAK_FORMAT: FroalaFormatAttributes = { class: 'no-break' };
const NUM_GROUP_ICON_PATH =
  'M7.795,2.523l0,1.458l-3.887,0l0,16.038l3.887,0l0,1.458l-4.616,0c-0.403,0 -0.729,-0.326 -0.729,-0.729l0,-17.496c0,-0.403 0.326,-0.729 0.729,-0.729l4.616,0Zm8.748,0l4.278,0c0.403,0 0.729,0.326 0.729,0.729l0,17.496c0,0.403 -0.326,0.729 -0.729,0.729l-4.278,0l0,-1.458l3.549,0l0,-16.038l-3.549,0l0,-1.458Zm-4.543,7.804l4.601,-4.601l1.673,1.673l-4.601,4.601l4.601,4.601l-1.673,1.673l-4.601,-4.601l-4.601,4.601l-1.673,-1.673l4.601,-4.601l-4.601,-4.601l1.673,-1.673l4.601,4.601Z';

function removeNode(node: Element): void {
  node.remove();
}

function applyNoBreakStyle(span: HTMLElement): void {
  span.style.whiteSpace = 'nowrap';
}

export const numGroupCommand: FroalaCommand = {
  title: NUM_GROUP_TITLE,
  focus: true,
  undo: true,
  toggle: true,
  refreshAfterCallback: true,
  refresh($btn) {
    const isActive = this.format.is(NO_BREAK_TAG, NO_BREAK_FORMAT);

    $btn.toggleClass('fr-active', isActive).attr('aria-pressed', isActive);
  },
  callback() {
    this.format.toggle(NO_BREAK_TAG, NO_BREAK_FORMAT);
    this.el.querySelectorAll('.fr-class-no-break').forEach(removeNode);
    // En línea porque fuera del editor ningún CSS da estilo a .no-break: así el estilo viaja con el HTML.
    this.el.querySelectorAll<HTMLElement>('span.no-break').forEach(applyNoBreakStyle);
  },
};

FroalaEditor.DefineIcon(NUM_GROUP_COMMAND, { NAME: NUM_GROUP_COMMAND, PATH: NUM_GROUP_ICON_PATH });
FroalaEditor.RegisterCommand(NUM_GROUP_COMMAND, numGroupCommand);
